import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "reactstrap";

import shallow from "zustand/shallow";
import useCurrentAccountStore from "./AccountStore";
import AccountCustomerHeader from "./AccountCustomerHeader";

import AccountSummary from "./AccountSummary";
import AccountInventoryHeader from "./AccountInventoryHeader";
import AccountBalance from "./AccountBalance";
import AccountPayoff from "./AccountPayoff";
import Loading from "../components/loadingSpinner/Loading";

export const AccountContent = () => {
	const { buyer, account, isLoading, autoPays } = useCurrentAccountStore(
		(state) => state,
		shallow
	);
	const [autoPay, setAutoPay] = useState({});
	useEffect(() => {
		autoPays.filter((obj) => obj.active === true);
		if (autoPays.length > 0) {
			setAutoPay(autoPays[0]);
		}
		console.log(autoPay);
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<div style={{ minHeight: "1000px" }}>
				{(isLoading && <Loading containerStyle={{ height: "80vh" }} />) || (
					<Row>
						<Row className="">
							<div className="col-md-4">
								<Card className="pb-2 h-50">
									<AccountCustomerHeader />
								</Card>
								{account.salesType !== 4 && (
									<Card className="pb-2 h-50">
										<AccountInventoryHeader />
									</Card>
								)}
							</div>
							<div className="col-md-5">
								<Card className="py-2 h-100">
									<AccountBalance />
								</Card>
							</div>
							<div className="col-md-3">
								<Card className="py-2 h-100">
									<AccountSummary />
								</Card>
							</div>
						</Row>
						<Row className="pt-2">
							<AccountPayoff />
							{(autoPay.active && (
								<label className="text-center"> Auto Pay is Active</label>
							)) || (
								<label className="text-center"> Auto Pay is Not Active</label>
							)}
						</Row>
					</Row>
				)}
			</div>
		</>
	);
};
